"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9436],{

/***/ 19436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NavigationMenu": function() { return /* binding */ NavigationMenu; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(81458);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/NavigationBarC/NavigationMenuItem.tsx












var LinkStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Link/* Link */.r, {
    target: "esasr7g0"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        color: theme.theme_component_navigation_menu_c_item_color || theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.theme_component_navigation_menu_c_item_hover_background_color || theme.palette.action.hover,
            color: theme.theme_component_navigation_menu_c_item_hover_color || undefined
        },
        "&:active": {
            backgroundColor: theme.theme_component_navigation_menu_item_c_active_background_color || theme.palette.action.active,
            color: theme.theme_component_navigation_menu_c_item_active_color || undefined
        }
    };
});
var ListItemIconStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ListItemIcon/* default */.Z, {
    target: "esasr7g1"
})(function(param) {
    var theme = param.theme, width = param.width, height = param.height;
    return {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(2),
        minWidth: "unset",
        width: width,
        height: height,
        "& > span": {
            flex: 1
        }
    };
});
var NavigationMenuItem_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var NavigationMenuItem = function(props) {
    var href = props.href, title = props.title, icon = props.icon, dense = props.dense;
    var theme = (0,useTheme/* default */.Z)();
    var iconColorStyle = theme.palette.primary.contrastText;
    var subtitle1Ref = react.useRef(null);
    var Icon = typeof (icon === null || icon === void 0 ? void 0 : icon[0]) === "function" ? icon[0] : undefined;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkStyled, {
        href: href,
        title: title,
        underline: "none",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListItemButton/* default */.Z, {
            dense: dense,
            children: [
                Icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemIconStyled, {
                    width: 26,
                    height: 26,
                    children: Icon ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                        color: iconColorStyle
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        src: icon === null || icon === void 0 ? void 0 : icon[0],
                        alt: title || "image",
                        width: 26,
                        height: 26
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemText/* default */.Z, {
                    primary: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationMenuItem_Typography, {
                        ref: subtitle1Ref,
                        variant: "subtitle1",
                        component: "span",
                        noWrap: true,
                        children: title
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(17417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(96514);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(45111);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuList/MenuList.js + 1 modules
var MenuList = __webpack_require__(84118);
;// CONCATENATED MODULE: ./src/components/NavigationBarC/NavigationMenu.tsx



















var NavigationMoreMenuItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(NavigationMenuItem, {
    target: "ewspc9g0"
})(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0.5, 2),
        color: theme.theme_component_navigation_menu_more_menu_item_color || theme.palette.text.primary
    };
});
var NavigationMoreMenuPaper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z, {
    target: "ewspc9g1"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.theme_component_navigation_bar_background_color || theme.palette.primary.main
    };
});
var NavigationMoreMenuLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z, {
    target: "ewspc9g2"
})(function(param) {
    var theme = param.theme;
    return {
        whiteSpace: "nowrap",
        textTransform: "capitalize",
        color: theme.theme_component_navigation_menu_more_menu_button_label_color || theme.palette.primary.contrastText,
        fontSize: "16px"
    };
});
var NavigationMoreMenuButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "ewspc9g3"
})(function(param) {
    var theme = param.theme;
    return {
        marginLeft: "auto",
        color: theme.theme_component_navigation_menu_more_menu_button_down_icon_color || theme.palette.primary.contrastText
    };
});
var ArrowDropdownIconStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ArrowDropDown/* default */.Z, {
    target: "ewspc9g4"
})(function(param) {
    var theme = param.theme;
    return {
        marginLeft: "auto",
        color: theme.theme_component_navigation_menu_more_menu_button_down_icon_color || theme.palette.primary.contrastText
    };
});
var NavigationMenu = function(props) {
    var sliceAmount = props.sliceAmount, size = props.size;
    var theme = (0,useTheme/* default */.Z)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var t = (0,esm/* useTranslation */.$G)("navigation_menu_b").t;
    var assetUrl = appContext.useConfig().assetUrl;
    var ref = appContext.useCategories(), categories = ref.categories, isLoading = ref.isLoading;
    var anchorRef = react.useRef(null);
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(sliceAmount), 2), sliceIndex = ref2[0], setSliceIndex = ref2[1];
    var belowLg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    var lg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    var handleToggle = function() {
        setOpen(function(prevOpen) {
            return !prevOpen;
        });
    };
    var handleClose = function(event) {
        // @ts-ignore
        if (event && anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    var handleListKeyDown = function(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === "Escape") {
            setOpen(false);
        }
    };
    react.useEffect(function() {
        setSliceIndex(sliceAmount);
        return function() {
            setSliceIndex(10);
        };
    }, [
        sliceAmount
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinearProgress/* default */.Z, {
                color: "secondary"
            }),
            categories && categories.slice(0, sliceIndex).map(function(item, index) {
                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationMenuItem, {
                    title: item.name,
                    href: (item === null || item === void 0 ? void 0 : item.slug) ? "/category/".concat(item.slug) : "".concat(item.href),
                    icon: item.icons,
                    dense: true
                }, index);
            }),
            lg && categories && categories.slice(sliceIndex).length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavigationMoreMenuButton, {
                        ref: anchorRef,
                        id: "more-menu-button",
                        "aria-controls": open ? "more-menu" : undefined,
                        "aria-expanded": open ? "true" : undefined,
                        "aria-haspopup": "true",
                        size: size,
                        onClick: handleToggle,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationMoreMenuLabel, {
                                variant: "inherit",
                                children: t("button.more", "More")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDropdownIconStyled, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Popper/* default */.Z, {
                        open: open,
                        anchorEl: anchorRef.current,
                        role: undefined,
                        placement: "bottom-end",
                        transition: true,
                        disablePortal: true,
                        placeholder: "",
                        style: {
                            zIndex: 1000
                        },
                        children: function(param) {
                            var TransitionProps = param.TransitionProps, placement = param.placement;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grow/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TransitionProps), {
                                style: {
                                    transformOrigin: placement === "bottom-start" ? "right top" : "right bottom"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationMoreMenuPaper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClickAwayListener/* default */.Z, {
                                        onClickAway: handleClose,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuList/* default */.Z, {
                                            autoFocusItem: open,
                                            id: "more-menu",
                                            "aria-labelledby": "more-menu-button",
                                            onKeyDown: handleListKeyDown,
                                            children: categories && categories.slice(sliceIndex).map(function(item, index) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationMoreMenuItem, {
                                                    title: item.name,
                                                    href: "/collection/".concat(item.code),
                                                    icon: item.icons,
                                                    dense: true
                                                }, index);
                                            })
                                        })
                                    })
                                })
                            }));
                        }
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ })

}]);